import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";


export default class Projects {
  constructor() { this.init(); }

  init() {
    const sliderEl = document.querySelector('.js-projects-slider');
    if (!sliderEl) return;

    new Swiper(".js-projects-slider", {
      modules: [Navigation, Pagination],
      slidesPerView: 3,
      spaceBetween: 20,
      navigation: {
        nextEl: ".js-projects-next",
        prevEl: ".js-projects-prev",
      },
      pagination: { el: ".js-projects-pagination", clickable: true },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 14, slidesPerGroup: 1 },
        640: { slidesPerView: 2, spaceBetween: 16, slidesPerGroup: 2 },
        1024: { slidesPerView: 3, spaceBetween: 20, slidesPerGroup: 3 },
      },
      observer: true,
      observeParents: true,
    });

  }
}
